import { render, staticRenderFns } from "./SparkleIntegration.vue?vue&type=template&id=abdab898&"
import script from "./SparkleIntegration.vue?vue&type=script&lang=js&"
export * from "./SparkleIntegration.vue?vue&type=script&lang=js&"
import style0 from "./SparkleIntegration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports